export default __webpack_public_path__ + "static/media/mh.38903f27.svg";